module.exports = {"apiKey":"AIzaSyBPNTLqYwpr1hcl1DlCCSgtHoA1eOS59f8","authDomain":"chiahao-92b7e.firebaseapp.com","databaseURL":"https://chiahao-92b7e.firebaseio.com","projectId":"chiahao-92b7e","storageBucket":"chiahao-92b7e.appspot.com","messagingSenderId":"1066414364145"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase/config.json
// module id = KyJT
// module chunks = 2